export class FieldSelectorSelection {
    public Selections: Array<any> = new Array<any>();
    public RestrictToEntityTypes: Array<any> = new Array<any>();
    public RestrictToFields: Array<any> = new Array<any>();
    public SingleSelect: boolean = false;
}
